<script>
/**
 * ****************************************************************************
 * @description     :   FilterButton
 * @created at      :   2022/07/28
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import repository from '@/utils/repository';
import _ from 'lodash';
import uuid from 'lodash-uuid';
import PopupFilter from '@/views/popup/filter';

/**
 * import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define main layout
 */
const FilterButton = {
    name: 'FilterButton',
    template: template,
    props: {
        modelValue: String | Number,
        typeFilter: String | Number,
        id: String,
        screen: String,
        itemClass: String,
        isUseOriginUser: {
            type: Boolean,
            default: false
        },
        onChangeEvent: Function
    },
    emits: ['update:modelValue'],
    components: {
        PopupFilter
    },
    data() {
        return {
            showFilter: false,
            newId: this.id,
            filters: [],
            isFirstCall: true,
            haveData: false
        };
    },
    computed: {
        selectedName() {
            const filter = _.find(this.filters ?? [], (x) => {
                return (
                    x.filterno ==
                    (helpers.isNullOrEmpty(this.modelValue)
                        ? '0'
                        : this.modelValue)
                );
            });
            if (filter) {
                return filter;
            }
            return {
                filterno: 0,
                filtername: 'フィルターグループ',
                fullName: 'フィルターグループ',
                selectno: 1,
                inputenable: 1,
                checkenable: 0,
                check: 0
            };
        },
        haveGroupFilter() {
            if (this.groupFilter) {
                return true;
            }
            return false;
        },
        groupFilter() {
            const filter = _.find(this.filters ?? [], {
                // eslint-disable-next-line prettier/prettier
                filtername: this.screen == 'gr0400r' ? '振替一覧' : this.screen == 'gr5900r' ? undefined : '承認グループ'
            });
            return filter;
        },
        noCheckBox() {
            return !_.find(this.filters ?? [], (x) => {
                return x.checkenable == 1;
            });
        }
    },
    created() {
        if (!this.newId) {
            this.newId = uuid.uuid();
        }
        this.isFirstCall = true;
        this.getFilters();
    },
    methods: {
        getFilters(input) {
            repository
                .get(`/common/filters`, {
                    params: {
                        isUseOriginUser: this.isUseOriginUser ? 1 : 0,
                        screen: this.screen
                    }
                })
                .then((res) => {
                    const { data } = res;
                    this.haveData = true;
                    if (data.Code === 200) {
                        this.filters = _.map(data.Data ?? [], (x) => {
                            return {
                                filterno: x.filterno,
                                filtername:
                                    x.filtername.length > 10
                                        ? x.filtername.substring(0, 10)
                                        : x.filtername,
                                fullName: x.filtername,
                                selectno: x.selectno,
                                inputenable: x.inputenable,
                                check: x.check == 1,
                                checkenable: x.checkenable
                            };
                        });
                        let selected = null;
                        if (
                            helpers.isNullOrEmpty(this.modelValue) ||
                            this.modelValue == 0 ||
                            input?.forceChange
                        ) {
                            selected = _.find(this.filters ?? [], (x) => {
                                return (
                                    (input?.filterno &&
                                        input?.filterno == x.filterno) ||
                                    x.selectno == '1'
                                );
                            });
                        }
                        if (!selected) {
                            selected = this.selectedName;
                        }
                        this.setFilter(selected);
                    } else {
                        this.filters = [];
                    }
                });
        },
        // eslint-disable-next-line no-unused-vars
        changeCheckDefault(item, e) {
            const body = {
                isUseOriginUser: this.isUseOriginUser ? 1 : 0,
                checked: item.check === true ? 1 : 0
            };
            const tmp = {};
            if (item.check) {
                tmp.checkId = item.filterno;
                const unCheckFilter = _.find(this.filters, (x) => {
                    return x.check && x.filterno != item.filterno;
                });
                if (unCheckFilter) {
                    unCheckFilter.check = false;
                    tmp.unCheckId = unCheckFilter.filterno;
                }
            } else {
                tmp.unCheckId = item.filterno;
            }
            repository
                .put(`/common/filters/${item.filterno ?? 0}/save-check`, body)
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.getFilters({
                            forceChange: true
                        });
                        // eslint-disable-next-line no-undef
                        // $(e.target).closest('.dropdown-item').click();
                    } else {
                        const unCheckFilter = _.find(this.filters, (x) => {
                            return x.filterno == tmp.unCheckId;
                        });
                        if (unCheckFilter) {
                            unCheckFilter.check = true;
                        }
                        const checkFilter = _.find(this.filters, (x) => {
                            return x.filterno == tmp.checkId;
                        });
                        if (checkFilter) {
                            checkFilter.check = false;
                        }
                    }
                });
        },
        setFilter(item, forceUpdate = true) {
            if (forceUpdate || item.filterno != this.modelValue) {
                // eslint-disable-next-line no-undef
                $('#' + this.newId).RemoveError();
                this.$emit('update:modelValue', item.filterno);
                if (this.onChangeEvent) {
                    this.onChangeEvent(item);
                }
            }
        },
        showPopupFilter() {
            this.showFilter = true;
        }
    }
};
export default FilterButton;
</script>
